
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Session from "@/models/Session";
import { mapState } from "vuex";
import Building from "@/models/Building";
import moment, * as Moment from "moment";
import { extendMoment } from "moment-range";
import * as sessiondate_helper from "@/helpers/sessiondate_helper"
import { FormatString } from "@/helpers/functions";
import { useDevice } from "@/helpers/DeviceState"

@Component({
  computed: mapState("EventRegistration", ["selectedSessions"])
})
export default class SessionDetails extends Vue {
  @Prop()
  session!: Session;

  showDescription = false;
  selected = false;

  toggle(e: Event) {
    e.preventDefault();

    if (this.selected && this.session.groupcode) {
      const selSessions =
        this.$store.state.EventRegistration.selectedSessions.map(
          (id: string) => {
            return this.$store.state.EventRegistration.sessionsById[id];
          }
        );

      const notright =
        selSessions.filter(
          (s: {
            parentSession: { id: string | undefined };
            groupcode: string;
          }) =>
            s.parentSession.id == this.session.parentSession?.id &&
            (s.groupcode == this.session.groupcode || !this.session.groupcode)
        ).length > 0;
      if (notright) {
        this.selected = false;
        return;
      }
    }

    if (this.limited && this.available === 0 && !this.alreadySelected) {
      this.selected = false;
      return;
    }

    this.$store.commit("EventRegistration/changeSelection", {
      id: this.session.id,
      selected: this.selected
    });
  }

  get header() {
    return this.session.name; // + " (groepscode: " + this.session.groupcode  + ")" + (this.session.withoutDate ? " (zonder datum)" : "");
  }

  get withoutDateLabel() {

    if (this.$store.state.EventRegistration.event.eventtype == "806970014")
      return this.$t("er.withoutDate806970014");
    else
      return this.$t("er.withoutDate");
  }

  get available() {
    return this.session.maxCapacity - this.session.registrationCount;
  }
  // Add max_sessionregistrations
  get limited() {
    return this.session.maxCapacity > 0;
  }

  get isSelected() {
    const selSessions =
      this.$store.state.EventRegistration.selectedSessions.map((id: string) => {
        return this.$store.state.EventRegistration.sessionsById[id];
      });
    return (
      selSessions.filter((s: Session) => s.id == this.session.id).length > 0
    );
  }

  get canSelect() {
    const selSessions =
      this.$store.state.EventRegistration.selectedSessions.map((id: string) => {
        return this.$store.state.EventRegistration.sessionsById[id];
      });
    if (this.session.groupcode) {
      return (
        selSessions.filter(
          (s: { parentSession: { id: string | undefined }; groupcode: string }) =>
            s.parentSession.id == this.session.parentSession?.id &&
            (s.groupcode == this.session.groupcode || !this.session.groupcode)
        ).length == 0
      );
    }
    if (this.session.wachtlijst) {
      return selSessions.filter(
        (s: { parentSession: { id: string | undefined }; groupcode: string; wachtlijst: boolean }) =>
          s.parentSession.id == this.session.parentSession?.id).length == 0;
    }
    return selSessions.filter(
      (s: { parentSession: { id: string | undefined }; groupcode: string; wachtlijst: boolean }) =>
        s.parentSession.id == this.session.parentSession?.id).length == 0;
  }

  get wachtlijstSelected() {
    const selSessions =
      this.$store.state.EventRegistration.selectedSessions.map((id: string) => {
        return this.$store.state.EventRegistration.sessionsById[id];
      });

    return selSessions.filter(
      (s: { parentSession: { id: string | undefined }; groupcode: string; wachtlijst: boolean }) =>
        s.parentSession.id == this.session.parentSession?.id &&
        s.wachtlijst).length > 0;
  }

  get showTimeOverlapWarning() {
    if (this.isSelected) {
      if (this.OnlineOpenDay) {
        const extMoment = extendMoment(Moment);
        const sessionRange = extMoment.range(new Date(this.session.start), new Date(this.session.end));
        const selSessionsWithOverlap =
          this.$store.state.EventRegistration.selectedSessions
            .map((id: string) => {
              return this.$store.state.EventRegistration.sessionsById[id];
            })
            .filter((s: Session) => {
              const sRange = extMoment.range(new Date(s.start), new Date(s.end));
              return sRange.overlaps(sessionRange, { adjacent: false });
            });
        const session_index = selSessionsWithOverlap.findIndex((s: Session) => s.id == this.session.id);
        return selSessionsWithOverlap.length > 1 && session_index >= 1;
      }
    }
    return false;
  }

  get OnlineOpenDay() {
    switch (this.$store.state.EventRegistration.event.eventtype) {
      case "806970012":
        return true;
      default:
        return false;
    }
  }

  get timeCheckOk() {
    if (this.session.tijdscontrole == false) return true;

    const extMoment = extendMoment(Moment);
    const selSessionsWithTimeCheck =
      this.$store.state.EventRegistration.selectedSessions
        .map((id: string) => {
          return this.$store.state.EventRegistration.sessionsById[id];
        })
        .filter((s: Session) => s.tijdscontrole == true);

    if (selSessionsWithTimeCheck.length == 0) return true;

    const sessionRange = extMoment.range(
      new Date(this.session.start),
      new Date(this.session.end)
    );
    let outSideRange = true;
    selSessionsWithTimeCheck.forEach((s: Session) => {
      if (s.id != this.session.id) {
        const sRange = extMoment.range(new Date(s.start), new Date(s.end));
        outSideRange =
          outSideRange && !sessionRange.overlaps(sRange, { adjacent: false });
      }
    });

    return outSideRange;
  }

  get alreadySelected() {
    let alreadySelected = false;
    if (this.$store.state.EventRegistration.portalProcessing != null) {
      alreadySelected =
        this.$store.state.EventRegistration.portalProcessing.sessieGuids.includes(
          this.session.id
        );
    }
    return alreadySelected;
  }

  get IsMaxSessionRegistrations() {
    if (this.$store.state.EventRegistration.event.maxSessionRegistrations) {
      if (this.$store.state.EventRegistration.selectedSessions.length >= this.$store.state.EventRegistration.event.maxSessionRegistrations)
        return true;
    }
    return false;
  }

  sessiesoort() {
    console.log(this.$store.state.EventRegistration.event.eventtype);
    switch (this.$store.state.EventRegistration.event.eventtype) {
      case "806970013":
        return "proefstudeerdag";
      case "806970015":
        return "rondleiding";
      default:
        return "retert";
    }
  }

  afmeldenWachtlijst()
  {
     return FormatString(this.$tc("er.afmeldenWachtlijst"), this.sessiesoort());
  }

  aanmeldenWachtlijst()
  {
     return FormatString(this.$tc("er.aanmeldenWachtlijst"), this.sessiesoort());
  }

  WachtlijstKop()
  {
     return FormatString(this.$tc("er.wachtlijstkop"), this.sessiesoort());
  }

  FormatDate() {
    const sessionStartDate = new Date(this.session.start);
    return moment(sessionStartDate).format("D MMMM YYYY");
  }

  FormatStartTime() {
    const sessionStartDate = new Date(this.session.start);
    return moment(sessionStartDate).format("HH:mm")
  }

  FormatEndTime() {
    const sessionEndDate = new Date(this.session.end);

    if (this.$i18n.locale == "nl")
      return moment(sessionEndDate).format("HH:mm")
    else
      return moment(sessionEndDate).format('HH:mm') + " CET";
  }

  GetBuilding(value: Building): string {
    if (value.id == "empty") return this.$tc("er.noLocationAvailable");
    else
    {
      if (useDevice().isMobile)
        return value.name.replace("Prof. Molkenboerstraat", "Prof. Molkenboer-straat").replace("Ruitenberglaan", "Ruitenberg-laan").replace("Heyendaalseweg", "Heyendaalse-weg").replace("Groenewoudseweg","Groene-woudseweg");
      else
        return value.name;
    }
  }

  @Watch("selectedSessions", { immediate: true })
  selectedSessionsChanged(sessionIds: string[]) {
    this.selected = !!sessionIds.find(s => s === this.session.id);
  }
}
